import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import { Adhere2CourseLine } from './Adhere2CourseLine';
import { CoursService } from '../../../services/CoursService';
import { SubscriptionsService } from '../../../services/SubscriptionService';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';

interface Props {
    register?: (form: FormAdhere2) => void;
    hidden: boolean;
    disabled: boolean;
    switch?: (n: number) => void;
    user_id: number;
}

/*interface GetForm {
    idCoursesChosen: number[];
    modePayment: string;
    EmptyCoursesChosen: boolean;
    nbrCheques: number | null;
}*/

interface State {
    coursesChosen: boolean[];
    listCourses: ReqType.Course[];
    tarifs: ReqType.Tarif[];
    payEspece: boolean;
    payCheque: boolean;
    unCheque: boolean;
    deuxCheques: boolean;
    troisCheques: boolean;
}

/**
 * Ce composant permet l'affichage du fomulaire d'adhesion partie2
 */
export class FormAdhere2 extends React.Component {

    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        if (this.props.register !== undefined) {
            this.props.register(this);
        }

        this.state = {
            coursesChosen: [],
            listCourses: [],
            tarifs: [],
            payEspece: false,
            payCheque: false,
            unCheque: false,
            deuxCheques: false,
            troisCheques: false,
        };
        // this.getForm(); SI CA PLANTE C'EST ICI
        this.getCourses();
        this.getSubscription();
        this.getTarif();
    }

    public getTarif() {
        SubscriptionsService.getInstance().getTarif()
            .then(
                (response) => {
                    this.setState({tarifs: response});
                }
            ).catch((reason) => {
            alert(reason);
        });
    }

    public getForm(): ReqType.SubscriptionPart2 {
        var idCoursesChosen: number[] = []; // Tableau qui va contenir la liste des id des cours
        var modePayment: ReqType.ModeReglement = ReqType.ModeReglement.UNDEFINED;
        var nbrCheques: number | null = 0;
        this.state.coursesChosen.map((bool: Boolean, indice: number) => {
            if (bool) {
                idCoursesChosen.push(indice);
            }
        });
        if (this.state.payCheque) {
            modePayment = ReqType.ModeReglement.CHEQUE;
        } else if (this.state.payEspece) {
            modePayment = ReqType.ModeReglement.ESPECES;
        }
        if (this.state.payEspece) {
            nbrCheques = null;
        } else {
            if (this.state.unCheque) {
                nbrCheques = 1;
            } else if (this.state.deuxCheques) {
                nbrCheques = 2;
            } else if (this.state.troisCheques) {
                nbrCheques = 3;
            } else {
                nbrCheques = null;
            }
        }

        return {
            cours: idCoursesChosen,
            mode_reglement: modePayment,
            nombre_cheque: nbrCheques === null ? null : nbrCheques.toString(),
        };
    }

    getCourses = () => {
        CoursService.getInstance().getCoursList()
            .then(
                (listCourses) => {
                    /*var arr: boolean[] = [];
                    listCourses.map((course: ReqType.Course) => {
                        arr[course.id] = false;
                    });*/
                    return ({ listCourses: listCourses, /*coursesChosen: arr*/ });
                }
            ).then(
                (object) => {
                    this.setState(object);
                }
            ).catch((reason) => {
                alert(reason);
            });
    }

    previousPage = () => {
        if (this.props.switch !== undefined) {
            this.props.switch(1);
        }
    }

    setDisable = () => {
        if (this.props.disabled === true) {
            return (this.props.disabled);
        } else {
            return (!this.state.payCheque);
        }
    }

    nextPage = () => {
        var EmptyCoursesChosen: boolean = false; // juste pour tester si le user à choisi au moins un creneau
        var idCoursesChosen: number[] = []; // Tableau qui va contenir la liste des id des cours
        var modePayment: ReqType.ModeReglement;
        var nbrCheques: number | null;
        this.state.coursesChosen.map((bool: Boolean, indice: number) => {
            if (bool) {
                idCoursesChosen.push(indice);
                EmptyCoursesChosen = true;
            }
        });
        if (!EmptyCoursesChosen) {
            return Promise.resolve().then(
                () => {
                    alert('Veuillez choisir un cours.');
                    return Promise.reject('');
                }
            );
        } else if (!this.state.payCheque && !this.state.payEspece) {
            return Promise.resolve().then(
                () => {
                    alert('Veuillez choisir un mode de payement.');
                    return Promise.reject('');
                }
            );
        } else if (this.state.payCheque && !this.state.unCheque && !this.state.deuxCheques
            && !this.state.troisCheques) {
            return Promise.resolve().then(
                () => {
                    alert('Entrer le nombre de cheques');
                    return Promise.reject('');
                }
            );
        } else {
            if (this.state.payCheque) {
                modePayment = ReqType.ModeReglement.CHEQUE;
            } else {
                modePayment = ReqType.ModeReglement.ESPECES;
            }
            if (this.state.payEspece) {
                nbrCheques = null;
            } else {
                if (this.state.unCheque) {
                    nbrCheques = 1;
                } else if (this.state.deuxCheques) {
                    nbrCheques = 2;
                } else if (this.state.troisCheques) {
                    nbrCheques = 3;
                } else {
                    nbrCheques = null;
                }
            }
            return (SubscriptionsService.getInstance().createSubscribePart2(
                {
                    cours: idCoursesChosen,
                    mode_reglement: modePayment,
                    nombre_cheque: nbrCheques === null ? null : nbrCheques.toString(),
                },
                this.props.user_id
            ).then(
                () => {
                    if (this.props.switch !== undefined) {
                        this.props.switch(3);
                    }
                }
            ));
        }
    }

    public SetCourses = (course: number) => {
        this.state.coursesChosen[course] = !this.state.coursesChosen[course];
        this.setState({ coursesChosen: this.state.coursesChosen });
    }

    setPayCheque = () => {
        this.state.payCheque = !this.state.payCheque;
        this.setState({ payCheque: this.state.payCheque });
        if (this.state.payCheque === this.state.payEspece && this.state.payEspece === true) {
            this.setState({ payEspece: !this.state.payEspece });
        }
    }

    setPayEspece = () => {
        this.state.payEspece = !this.state.payEspece;
        this.setState({ payEspece: this.state.payEspece });
        if (this.state.payCheque === this.state.payEspece && this.state.payCheque) {
            this.setState({ payCheque: !this.state.payCheque });
        }
        this.setState({
            unCheque: false,
            deuxCheques: false,
            troisCheques: false,
        });
    }

    setUnCheque = () => {
        this.state.unCheque = !this.state.unCheque;
        this.setState({ unCheque: this.state.unCheque });
        if (this.state.unCheque === this.state.deuxCheques && this.state.deuxCheques) {
            this.setState({ deuxCheques: !this.state.deuxCheques });
        }
        if (this.state.unCheque === this.state.troisCheques && this.state.troisCheques) {
            this.setState({ troisCheques: !this.state.troisCheques });
        }
    }

    setDeuxCheque = () => {
        this.state.deuxCheques = !this.state.deuxCheques;
        this.setState({ deuxCheques: this.state.deuxCheques });
        if (this.state.deuxCheques === this.state.unCheque && this.state.unCheque) {
            this.setState({ unCheque: !this.state.unCheque });
        }
        if (this.state.deuxCheques === this.state.troisCheques && this.state.troisCheques) {
            this.setState({ troisCheques: !this.state.troisCheques });
        }
    }

    setTroisCheque = () => {
        this.state.troisCheques = !this.state.troisCheques;
        this.setState({ troisCheques: this.state.troisCheques });
        if (this.state.troisCheques === this.state.deuxCheques && this.state.deuxCheques) {
            this.setState({ deuxCheques: !this.state.deuxCheques });
        }
        if (this.state.troisCheques === this.state.unCheque && this.state.unCheque) {
            this.setState({ unCheque: !this.state.unCheque });
        }
    }

    render() {
        var tarifs = this.state.tarifs.map(
            (tarif: ReqType.Tarif) => {
                return (
                    <tr key={tarif.id}>
                        <td>{tarif.libelle}</td>
                        <td>{tarif.valeur}</td>
                    </tr>
                );
            }
        );
        const hStyle = {
            color: '#ED008C',
            paddingTop : '30px',
            paddingBottom: '50px',
            fontSize: '40px'
        };
        const listItems = this.state.listCourses.map(
            (course: ReqType.Course) => {
                if (course.status === 1) {
                    return (
                        <Adhere2CourseLine
                            add={this.SetCourses}
                            course={course}
                            key={course.id}
                            disabled={this.props.disabled}
                            checked={this.state.coursesChosen[course.id]}
                        />
                    );
                } else {
                    return undefined;
                }
            }
        );
        return (
            <div>
                <div>
                    <h2 className="text-center" style={hStyle} hidden={this.props.hidden}>Bulletin d'adhésion</h2>
                    <h3
                        hidden={this.props.hidden}
                        className="text-center"
                        style={{float: 'left', marginBottom: '2cm'}}
                    >
                        Cours suivis: ( choisir un ou plusieurs creneaux dans la liste)
                    </h3>
                    <br/>
                    <hr hidden={this.props.hidden}/>
                    <TableChorinitia
                        header={
                            <thead className="thead-light">
                                <tr>
                                    <th scope="col">Disciplines</th>
                                    <th scope="col">Jours</th>
                                    <th scope="col">Horaires</th>
                                    <th scope="col">Lieux</th>
                                    <th scope="col">Créneau désiré</th>
                                </tr>
                            </thead>
                        }
                    >
                        <tbody>
                            {listItems}
                        </tbody>
                    </TableChorinitia>
                    <h3 style={{float: 'left', marginTop: '1cm'}} hidden={this.props.hidden}>
                        Tarifs
                    </h3>
                    <br/>
                    <table className="table table-sm" hidden={this.props.hidden}>
                        <tbody>
                            {tarifs}
                        </tbody>
                    </table>
                    <h3 style={{float: 'left', marginBottom: '1cm', marginLeft: '1px', width: '100%'}} className="row">
                        Mode de réglement:
                    </h3>
                    <br/>
                    <hr/>
                    <div className="form-check form-check-inline">
                        <label className="form-check-label">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="inlineCheckbox1"
                                value="option1"
                                disabled={this.props.disabled}
                                checked={this.state.payEspece}
                                onClick={this.setPayEspece}
                            /> Espèces
                        </label>
                    </div>
                    <div className="form-check form-check-inline">
                        <label className="form-check-label">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="inlineCheckbox2"
                                value="option2"
                                disabled={this.props.disabled}
                                checked={this.state.payCheque}
                                onClick={this.setPayCheque}
                            /> Chèque(s)
                        </label>
                    </div>
                    <label className="offset-1 col-md-3"> Nombre de chèques: </label>
                    <div className="form-check form-check-inline disabled">
                        <label className="form-check-label">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="inlineCheckbox3"
                                value="option3"
                                checked={this.state.unCheque}
                                disabled={this.setDisable()}
                                onClick={this.setUnCheque}
                            /> 1
                        </label>
                    </div>
                    <div className="form-check form-check-inline disabled">
                        <label className="form-check-label">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="inlineCheckbox3"
                                value="option3"
                                checked={this.state.deuxCheques}
                                disabled={this.setDisable()}
                                onClick={this.setDeuxCheque}
                            /> 2
                        </label>
                    </div>
                    <div className="form-check form-check-inline disabled">
                        <label className="form-check-label">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="inlineCheckbox3"
                                value="option3"
                                checked={this.state.troisCheques}
                                disabled={this.setDisable()}
                                onClick={this.setTroisCheque}
                            /> 3
                        </label>
                    </div>
                    <div
                        className="row"
                        hidden={this.props.hidden}
                        style={{float: 'right', marginRight: '1cm'}}
                    >
                        <button
                            className="btn"
                            onClick={this.previousPage}
                            style={{
                                marginBottom: '1cm',
                                height: '1.5cm',
                                marginTop: '1cm',
                                width: '4cm'}}
                        >
                            Precedent
                        </button>
                        <LoaderButton
                            className="btn"
                            onClick={this.nextPage}
                            style={{
                                marginLeft: '1cm',
                                marginBottom: '1cm',
                                height: '1.5cm',
                                marginTop: '1cm',
                                width: '4cm'}}
                        >
                            Suivant
                        </LoaderButton>
                    </div>
                </div>
            </div>
        );
    }

    private getSubscription() {
        SubscriptionsService.getInstance().getSubscribePart2(this.props.user_id).then(
            (req: ReqType.SubscriptionPart2) => {
                var arr: boolean[] = [];
                req.cours.map(
                    (cours: number) => {
                        arr[cours] = true;
                    }
                );

                this.setState(
                    {
                        coursesChosen: arr,
                        payEspece: req.mode_reglement === ReqType.ModeReglement.ESPECES,
                        payCheque: req.mode_reglement === ReqType.ModeReglement.CHEQUE,
                        unCheque: req.nombre_cheque === '1',
                        deuxCheques: req.nombre_cheque === '2',
                        troisCheques: req.nombre_cheque === '3',
                    }
                );
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MembershipPage/internalComponents/Adhere2.tsx